import React from "react";

export const BipartiteGraph = ({ className = "" }) => {
  const tasks = [
    { y: 60, label: "LLM-Train" },
    { y: 140, label: "Inference" },
    { y: 220, label: "Diffusion" },
    { y: 300, label: "FT-Job" },
    { y: 380, label: "MIG-slice" },
  ];
  const gpus = [
    { y: 40, label: "H100" },
    { y: 120, label: "A100" },
    { y: 200, label: "L40S" },
    { y: 280, label: "RTX 5090" },
    { y: 360, label: "RTX 4090" },
  ];
  const edges = [
    { from: 0, to: 0, w: 0.92 },
    { from: 0, to: 1, w: 0.78 },
    { from: 1, to: 3, w: 0.86 },
    { from: 1, to: 4, w: 0.71 },
    { from: 2, to: 2, w: 0.83 },
    { from: 2, to: 1, w: 0.69 },
    { from: 3, to: 0, w: 0.61 },
    { from: 3, to: 3, w: 0.74 },
    { from: 4, to: 2, w: 0.88 },
    { from: 4, to: 4, w: 0.66 },
  ];

  const TEXT = "#0A0F1E";
  const MUTED = "#5C6A82";
  const BRAND = "#0050E6";
  const CYAN = "#0099C9";
  const SURFACE = "#FFFFFF";

  return (
    <svg
      viewBox="0 0 480 440"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      data-testid="bipartite-graph"
    >
      <defs>
        <linearGradient id="edge-grad" x1="0" x2="1">
          <stop offset="0%" stopColor={BRAND} stopOpacity="0.85" />
          <stop offset="100%" stopColor={CYAN} stopOpacity="0.85" />
        </linearGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="1.6" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Edges */}
      {edges.map((e, i) => (
        <line
          key={i}
          x1={120}
          y1={tasks[e.from].y}
          x2={360}
          y2={gpus[e.to].y}
          stroke="url(#edge-grad)"
          strokeWidth={Math.max(0.8, e.w * 2)}
          opacity={0.45 + e.w * 0.4}
        >
          <animate
            attributeName="opacity"
            values={`${0.35 + e.w * 0.3};${0.65 + e.w * 0.3};${0.35 + e.w * 0.3}`}
            dur={`${3 + (i % 3)}s`}
            repeatCount="indefinite"
          />
        </line>
      ))}

      {/* Edge weights */}
      {edges.map((e, i) => {
        const x = (120 + 360) / 2 + (i % 2 === 0 ? -22 : 18);
        const y = (tasks[e.from].y + gpus[e.to].y) / 2;
        return (
          <text
            key={`w-${i}`}
            x={x}
            y={y}
            fontSize="9"
            fill={CYAN}
            fontFamily="JetBrains Mono"
            opacity="0.75"
          >
            {e.w.toFixed(2)}
          </text>
        );
      })}

      {/* Task nodes (left) */}
      {tasks.map((t, i) => (
        <g key={`t-${i}`}>
          <circle cx={120} cy={t.y} r="14" fill={SURFACE} stroke={CYAN} strokeWidth="1.8" filter="url(#glow)" />
          <text x={108} y={t.y - 22} fontSize="10" fontFamily="JetBrains Mono" fill={MUTED} textAnchor="end">
            T{i + 1}
          </text>
          <text x={108} y={t.y + 4} fontSize="10" fontFamily="JetBrains Mono" fill={TEXT} textAnchor="end">
            {t.label}
          </text>
        </g>
      ))}

      {/* GPU nodes (right) */}
      {gpus.map((g, i) => (
        <g key={`g-${i}`}>
          <rect x={350} y={g.y - 10} width="22" height="20" rx="3" fill={SURFACE} stroke={BRAND} strokeWidth="1.8" filter="url(#glow)" />
          <text x={382} y={g.y - 14} fontSize="10" fontFamily="JetBrains Mono" fill={MUTED}>
            R{i + 1}
          </text>
          <text x={382} y={g.y + 4} fontSize="10" fontFamily="JetBrains Mono" fill={TEXT}>
            {g.label}
          </text>
        </g>
      ))}

      {/* Column labels */}
      <text x={120} y={28} fontSize="10" fontFamily="JetBrains Mono" fill={BRAND} textAnchor="middle" letterSpacing="2">
        TASKS
      </text>
      <text x={360} y={28} fontSize="10" fontFamily="JetBrains Mono" fill={BRAND} textAnchor="middle" letterSpacing="2">
        GPU POOL
      </text>
    </svg>
  );
};

export default BipartiteGraph;
